module.exports = __webpack_public_path__ + "static/apoyo01-d3674627d801d473ce8ddf9c0264abe2.png";